export const modeDetail = {
  VIEW: "VIEW",
  CREATE: "CREATE",
  EDIT: "EDIT",
};

export const LIST_TYPE_ID = [
  {
    value: "1",
    label: "Doanh nghiệp",
  },
  {
    value: "2",
    label: "Khách lẻ",
  },
];

export const FIELD_CUSTOMER = {
  MA: "ma",
  TEN: "ten",
  IDNO: "idno",
  MST: "mst",
  CTY: "cty",
  STKNHANG: "stknhang",
  TNHANG: "tnhang",
  DCHI: "dchi",
  SDTHOAI: "sdthoai",
  DCTDTU: "dctdtu",
  FAX: "fax",
  TYPE_ID: "type_id",
};
